import { render, staticRenderFns } from "./InvoicesVE.vue?vue&type=template&id=327fef76&"
import script from "./InvoicesVE.vue?vue&type=script&lang=js&"
export * from "./InvoicesVE.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesVE.vue?vue&type=style&index=0&id=327fef76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports